import AdminList from '@/pages/preferences/AdminList.vue';
import ManageAccess from '@/pages/preferences/ManageAccess.vue';
import AccessIpManage from '@/pages/preferences/AccessIpManage.vue';
import DepartmentManage from '@/pages/preferences/DepartmentManage.vue';
import AccessLog from '@/pages/preferences/AccessLog.vue';

export default {
	AdminList: {
		id: 'AdminList',
		title: '관리자 계정 관리',
		heading: '관리자 계정 관리',
		path: '/preferences/admin-list',
		component: AdminList,
	},
	ManageAccess: {
		id: 'ManageAccess',
		title: '접속 아이피 설정',
		heading: '접속 아이피 설정',
		path: '/preferences/manage-access',
		component: ManageAccess,
	},
	AccessIpManage: {
		id: 'AccessIpManage',
		title: '접속 아이피 설정',
		heading: '접속 아이피 설정',
		path: '/preferences/access-ip-manage',
		component: AccessIpManage,
	},
	DepartmentManage: {
		id: 'DepartmentManage',
		title: '부서관리',
		heading: '부서관리',
		path: '/preferences/department-manage',
		component: DepartmentManage,
	},
	AccessLog: {
		id: 'AccessLog',
		title: '관리자 접속 로그',
		heading: '관리자 접속 로그',
		path: '/preferences/access-log',
		component: AccessLog,
	},
};
